import { Component } from '@angular/core';

@Component({
  selector: 'uni-list-item',
  templateUrl: './uni-list-item.component.html',
  styleUrls: ['./uni-list-item.component.scss'],
})
export class UniListItemComponent {}
